import { HttpApiSecurity as service } from 'app/http';

import { type RecoverPasswordState } from '../models/recoverPassword.model';

const baseUrl = 'v1/administration/recoverpasswordrequest';
const baseUrlRecover = '/v1/administration/recoverpassword';

/**
 * Servicios para la recuperación de contraseña de un usuario cuando se ha olvidado
 * de la misma.
 *
 * Para eso se envía un correo e electrónico al usuario con el token para permitir
 * la operación de definir una nueva contraseña
 *
 * @class PasswordRecoveryService
 */
class PasswordRecoveryService {
  /**
   * Crea una solicitud para reinicio de contraseña del usuario. Para eso se envía
   * la identificación del usuario para el cual se hará la nueva definición
   *
   * @param {string} [userName] Identificador del usuario (login)
   * @return {*}  {(Promise<Record<string, never> | { error: any }>)} En caso que se
   * devuelva un codigo de exito se entiende que la operación fue exitosa, caso
   * contrario se informa el detalle del error
   * @memberof PasswordRecoveryService
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  createRequest(userName?: string): Promise<Record<string, never> | { error: any }> {
    return service
      .post(baseUrl + '?userName=' + userName, {})
      .then(() => ({}))
      .catch((error) => ({ error }));
  }

  /**
   * Permite definir una nueva contraseña para el usuario una vez que se cuenta con un
   * codigo (token) que permite la operación de definición
   *
   * @param {RecoverPasswordState} [values] Información de la nueva contraseña definida
   * @return {*}  {(Promise<Record<string, never> | { error: any }>)}  En caso que se
   * devuelva un codigo de exito se entiende que la operación fue exitosa, caso
   * contrario se informa el detalle del error
   * @memberof PasswordRecoveryService
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  recoverPassword(values?: RecoverPasswordState): Promise<Record<string, never> | { error: any }> {
    return service
      .put(baseUrlRecover, values)
      .then(() => ({}))
      .catch((error) => ({ error }));
  }
}
export default new PasswordRecoveryService();
